var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditLyrics = function SvgEditLyrics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "m2.5 11.5 3 3-2.5 1a.521.521 0 0 1-.672-.672L3.5 12.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "m12.586 2 2.242 2.243a1 1 0 0 1 0 1.414l-8.585 8.586a.98.98 0 0 1-.72.284l-1.937-1.941a.98.98 0 0 1 .285-.72l8.586-8.586a1 1 0 0 1 1.414 0c-.39-.391-.39-.391-1.285-1.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6777FF",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M10.5 1h-8a1 1 0 0 0-1 1v7"
  })));
};
export default SvgEditLyrics;